<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="12" height="12" viewBox="0 0 4.199999809265137 8.600000381469727"><g><path d="M0,2.1C0,2.43137,0.268629,2.7,0.6,2.7C0.931371,2.7,1.2,2.43137,1.2,2.1C1.2,1.60294,1.60294,1.2,2.1,1.2C2.59706,1.2,3,1.60294,3,2.1C3,2.34404,2.90367,2.56435,2.74564,2.72702C2.6997,2.77431,2.64733,2.82657,2.59102,2.88277C2.40435,3.06907,2.17433,3.29863,1.99133,3.53377C1.74401,3.85155,1.5,4.27585,1.5,4.8L1.5,5.4C1.5,5.73137,1.76863,6,2.1,6C2.43137,6,2.7,5.73137,2.7,5.4L2.7,4.8C2.7,4.66141,2.7631,4.49594,2.93832,4.2708C3.07104,4.10027,3.22231,3.94913,3.39498,3.77661C3.46215,3.7095,3.53255,3.63915,3.60637,3.56317C3.97317,3.18558,4.2,2.66867,4.2,2.1C4.2,0.940202,3.2598,0,2.1,0C0.940202,0,0,0.940202,0,2.1ZM1.3,7.8C1.3,8.24183,1.65817,8.6,2.1,8.6C2.54183,8.6,2.9,8.24183,2.9,7.8C2.9,7.35817,2.54183,7,2.1,7C1.65817,7,1.3,7.35817,1.3,7.8Z" fill="#666666" fill-opacity="1"/></g></svg>
</template>

<script>
export default {
  name: "questionIcon"
}
</script>

<style scoped>

</style>